import { PaymentProvider } from "./billing";

export enum PaymentRetryErrorKind {
  PAYMENT_REFUSED = "paymentRefused",
  RETRY_UNAVAILABLE = "retryUnavailable",
  SESSION_ENDED = "sessionEnded",
  NETWORK_UNAVAILABLE = "networkUnavailable",
  UNKNOWN = "unknown",
  SEND_FAILED = "sendFailed",
  NOT_STARTED = "notStarted",
}

export interface PaymentRetryError {
  kind: PaymentRetryErrorKind;
  reason?: string;
  declineCode?: string;
  isRetryable: boolean;
}

export enum PaymentAttemptStatus {
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export type PaymentAttemptOutcome =
  | { status: PaymentAttemptStatus.SUCCEEDED }
  | { status: PaymentAttemptStatus.FAILED; error: PaymentRetryError };

export enum PaymentOptionKind {
  PAY_BY_CARD = "payByCard",
  RETRY_HSA_FSA = "retryHsaFsa",
}

// An option that names an `invoiceProvider` first creates the order's invoice with that provider;
// an option without one pays the order's existing invoice.
export interface PaymentOption {
  kind: PaymentOptionKind;
  invoiceProvider?: PaymentProvider;
}

export type PaymentMessageVariant = "success" | "error";

export interface PaymentMessage {
  variant: PaymentMessageVariant;
  text: string;
}
